export default Object.freeze({
    STAFET_JOIN_A_TEAM: 'stafetJoinATeamUserInputs',
    STAFET_DONATION: 'stafetDonationUserInputs',
    STAFET_JOIN_AS_FIGHTER: 'stafetJoinAsFighterUserInputs',
    STAFET_CREATE_A_TEAM: 'stafetCreateATeamUserInputs',
    ADD_DELTAGERE: 'addDeltagereUserInputs'
})
